import * as fromDatatype from "../datatype-library/index";

export interface bl_del_job_checklist_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_job_hdr: fromDatatype.GuidDataFieldInterface;
  dochdr_link_guid: fromDatatype.GuidDataFieldInterface;
  docline_link_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  expected_amount: fromDatatype.NumericDatatypeInterface;
  collected_amount: fromDatatype.NumericDatatypeInterface;
  payee_name: fromDatatype.VarcharDatatypeInterface;
  id_payee: fromDatatype.VarcharDatatypeInterface;
  payee_contact: fromDatatype.VarcharDatatypeInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_job_checklist_line_RowClass
  implements bl_del_job_checklist_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_job_hdr: fromDatatype.GuidDataFieldInterface;
  dochdr_link_guid: fromDatatype.GuidDataFieldInterface;
  docline_link_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  expected_amount: fromDatatype.NumericDatatypeInterface;
  collected_amount: fromDatatype.NumericDatatypeInterface;
  payee_name: fromDatatype.VarcharDatatypeInterface;
  id_payee: fromDatatype.VarcharDatatypeInterface;
  payee_contact: fromDatatype.VarcharDatatypeInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
